import { render, staticRenderFns } from "./column-dialog.vue?vue&type=template&id=24544096&scoped=true"
import script from "./column-dialog.vue?vue&type=script&lang=js"
export * from "./column-dialog.vue?vue&type=script&lang=js"
import style0 from "./column-dialog.vue?vue&type=style&index=0&id=24544096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24544096",
  null
  
)

export default component.exports